import { io, Socket } from 'socket.io-client';
import { getAuthToken } from '../api/client';
import { WS_BASE } from './wsBase';

let socket: Socket | null = null;

// Сокет коммунальной рулетки. Подключается к namespace /roulette на том же origin —
// Vite проксирует /socket.io на backend (см. vite.config.ts).
export function getRouletteSocket(): Socket {
  if (socket && socket.connected) return socket;
  if (!socket) {
    socket = io(WS_BASE + '/roulette', {
      auth: { token: getAuthToken() || '' },
      autoConnect: true,
    });
  } else {
    socket.auth = { token: getAuthToken() || '' };
    socket.connect();
  }
  return socket;
}

export function disconnectRouletteSocket() {
  socket?.disconnect();
}
